import React, { useState } from "react";
import { Modal } from "@mui/material";
import { XIcon } from "@heroicons/react/solid";
import { Button, Input } from "../../components/ui";
import { useForm } from "react-hook-form";
import InlineLoader from "../../components/loader/InlineLoader";
import toast from "react-hot-toast";
import usePut from "../../hooks/put/usePut";

const UpdateInvoiceNoModal = ({ open, onClose, transaction, refreshUrl }) => {
  const [savedInvoiceNo, setSavedInvoiceNo] = useState("");

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      invoice_no: transaction?.invoice_no || "",
    },
  });

  React.useEffect(() => {
    if (transaction) {
      reset({ invoice_no: transaction.invoice_no || "" });
    }
  }, [transaction, reset]);

  const { handleAuth: updateInvoiceMutation } = usePut({
    url: "petty-cash/update_invoice_no",
    refreshUrl: refreshUrl || ["petty-cash/transaction_listing", "petty-cash/fetch_single_transaction"],
    onSuccess: (res) => {
      toast.success(res?.data?.message || "Invoice number updated successfully");
      setSavedInvoiceNo(res?.data?.invoice_no || "");
      onClose();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to update invoice number");
    },
  });
  const { mutate: updateInvoice, isLoading: isUpdating } = updateInvoiceMutation;

  const onSubmit = (data) => {
    if (!transaction) return;
    updateInvoice({
      transaction_id: transaction.transaction_id,
      company_employee_id: transaction.company_employee_id,
      invoice_no: data.invoice_no,
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="w-full h-full md:h-auto md:w-[90%] lg:w-[60%] max-w-lg bg-white rounded-none md:rounded-2xl shadow-2xl absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 overflow-hidden border-0 md:border md:border-gray-150 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 bg-gray-50 border-b border-gray-200 flex-shrink-0">
          <h3 className="text-lg font-bold text-gray-800">Update Invoice Number</h3>
          <button
            onClick={onClose}
            disabled={isUpdating}
            className="p-1 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors disabled:opacity-50"
          >
            <XIcon className="w-5 h-5" />
          </button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-5">
          <Input
            control={control}
            label="Invoice/Voucher Number"
            name="invoice_no"
            placeholder="Enter invoice or voucher number"
            rules={{ required: "Invoice/Voucher number is required" }}
          />
          <div className="flex items-center justify-end space-x-3 pt-4 border-t border-gray-100">
            <Button type="button" variant="outline" onClick={onClose} disabled={isUpdating}>
              Cancel
            </Button>
            <Button type="submit" disabled={isUpdating}>
              {isUpdating ? (
                <>
                  <span>Saving...</span>
                  <InlineLoader className="ml-2" />
                </>
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default UpdateInvoiceNoModal;
